export default __webpack_public_path__ + "assets/images/Payment_06.9ffcf2.png";